import React from "react";
// 直接具体路径，不走 components barrel，否则会形成 components ↔ 本文件 的自环
import { Dialog } from "../Base/Dialog";
import { Button } from "../Base/Button";
import { useT } from "../../i18n/hooks";
import type { TooManyPasswordAttemptsDialogProps } from "./TooManyPasswordAttemptsDialog.types";
import "./TooManyPasswordAttemptsDialog.scss";

export const TooManyPasswordAttemptsDialog: React.FC<
  TooManyPasswordAttemptsDialogProps
> = ({ visible, onClose, supportUrl }) => {
  const t = useT();
  const linkText = t("auth.tooManyPasswordAttempts.support");
  const bodyRaw = t("auth.tooManyPasswordAttempts.body");
  const parts = bodyRaw.split(linkText);

  const bodyContent =
    supportUrl && parts.length >= 2 ? (
      <>
        {parts[0]}
        <a
          href={supportUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="too-many-attempts-dialog__support-link"
        >
          {linkText}
        </a>
        {parts.slice(1).join(linkText)}
      </>
    ) : (
      bodyRaw
    );

  return (
    <Dialog
      visible={visible}
      onClose={onClose}
      className="too-many-attempts-dialog"
      showCloseButton={false}
    >
      <div className="too-many-attempts-dialog__title">
        {t("auth.tooManyPasswordAttempts.title")}
      </div>
      <div className="too-many-attempts-dialog__body">{bodyContent}</div>
      <Button
        type="button"
        size="md"
        variant="tertiary"
        block
        className="too-many-attempts-dialog__submit"
        onClick={onClose}
      >
        {t("auth.tooManyPasswordAttempts.gotIt")}
      </Button>
    </Dialog>
  );
};
